// Паттерн "Наблюдатель" для управления состоянием
class StateManager {
    constructor(initialState) {
        this.state = initialState;
        this.listeners = [];
    }

    // Получение текущего состояния
    getState() {
        return this.state;
    }

    // Обновление состояния
    updateState(updater) {
        if (typeof updater === 'function') {
            this.state = this.deepMerge(this.state, updater(this.state));
        } else {
            this.state = this.deepMerge(this.state, updater);
        }
        this.notifyListeners();
    }

    deepMerge(target, source) {
        const result = { ...target };

        for (const key in source) {
            if (source.hasOwnProperty(key)) {
                if (this.isObject(source[key]) && this.isObject(target[key])) {
                    result[key] = this.deepMerge(target[key], source[key]);
                } else {
                    result[key] = source[key];
                }
            }
        }

        return result;
    }

    isObject(value) {
        return value && typeof value === 'object' && !Array.isArray(value);
    }

    // Подписка на изменения
    subscribe(listener) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }

    // Уведомление подписчиков
    notifyListeners() {
        this.listeners.forEach(listener => listener(this.state));
    }
}

// Начальное состояние приложения
const initialState = {
    auth: {
        user: null,
        isLoading: false,
        error: null
    },
    crypto: {
        selectedPair: 'BTC/USDT',
        priceData: null,
        isLoading: false,
        error: null
    },
    ui: {
        currentPage: 'dashboard',
        theme: 'dark',
        notifications: []
    }
};

const AppState = new StateManager(initialState);

window.AppState = AppState;